module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a02_title"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("FROM THE")]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_vm._v("DREADNOUGHT")]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("TO")]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_vm._v("SCAPA FLOW")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("The Royal Navy in the Fisher Era 1904–1919")]), _vm._v(" "), _c('p', {
    staticClass: "title4"
  }, [_vm._v("VOLUME III"), _c('br'), _vm._v("JUTLAND AND AFTER: MAY TO DECEMBER1916")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("ARTHUR J MARDER")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_vm._v("INTRODUCTION BY BARRY GOUGH")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("Naval Institute Press")]), _vm._v(" "), _c('p', {
    staticClass: "publoc"
  }, [_vm._v("Annapolis")]), _vm._v(" "), _c('p', {
    staticClass: "img1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plogo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c673c29c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_title.vue
// module id = 60
// module chunks = 0